import type { User } from '@/types/api/user';
import { TokenService } from '@/services/auth/tokenService';
import { atom } from 'jotai';

export const userAtom = atom<User | null>(null);

export const userInfoAtom = atom(() => {
  const tokenService = TokenService.getInstance();
  const userInfo = tokenService.getUserInfo();

  if (!userInfo) return null;

  return {
    id: userInfo.userId,
    email: userInfo.email,
    name: userInfo.name,
    role: 'operator' as const,
    createdAt: new Date(),
  };
});
